module.exports = __webpack_public_path__ + "media/images/flags/es-565198e29196011ebf811a3031ea5c4d.svg";